module.exports = __webpack_public_path__ + "img/icon_code.ae87bc42.svg";